module.exports = __webpack_public_path__ + "static/media/icon_search.c1cbde03.svg";